import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ImageFallbackDirective } from '@shared/directives/image-fallback.directive';
import { VersionDialogComponent } from '@theme/sidebar/version-dialog/version-dialog.component';

import { StringUtils } from '@shared/utils/stringUtils';

@Component({
  selector: 'app-sidebar-logo',
  templateUrl: './sidebar-logo.component.html',
  styleUrls: ['./sidebar-logo.component.scss'],
  imports: [ImageFallbackDirective],
})
export class SidebarLogoComponent {
  public sidebarLogo = StringUtils.brandResourceWithFallback('sidebarLogo');
  public fallbackLogo = StringUtils.brandResourceFallbackPath('sidebarLogo');

  private readonly dialog = inject(MatDialog);

  showVersionDialog(): void {
    this.dialog.open(VersionDialogComponent, {
      width: '400px',
      maxWidth: 'calc(100vw - 48px)',
      panelClass: 'version-dialog-panel',
    });
  }
}
